import { render } from "./HomePopularGames.vue?vue&type=template&id=1e7511d6&ts=true"
import script from "./HomePopularGames.vue?vue&type=script&lang=ts"
export * from "./HomePopularGames.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__